/*
 * Возвращает JSON безопасненько из строки
 * @param prop (String) - строка, из которой будет делать JSON
 */
function getJSON(prop, arrayAllowed = true) {

  if (typeof prop == "string" && this.isJSONString(prop))
    prop = JSON.parse(prop)

  if (!arrayAllowed && Array.isArray(prop))
    return {}

  if (!prop)
    return {}

  return prop
}

function isJSONString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function nl2br(value) {
  if (!value)
    return ''

  return value.split('\n').join('<br />')
}

function focusErrorField() {
  let inst = this
  inst.$nextTick().then(() => {
    let $errField = inst.$el.querySelectorAll(".error")[0]
    if ($errField) {
      let $errInput = $errField.querySelectorAll(".field__input")[0]
      if ($errInput)
        $errInput.focus()
      else {
        $errField.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  })
}

function showModal(id) {
  if (typeof Marquiz !== 'undefined') {
    Marquiz.showModal(id)

    try {
      typeof ym == 'function' && ym(26515410,'reachGoal','quizopened')
    } catch(err) {}
  }
}

export default {
  methods: {
    getJSON,
    isJSONString,
    showModal,
    nl2br,
    focusErrorField
  }
}
